import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";
import { LessonState } from "../views/lessons/constants";

export const useUpdateLessonState = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, state }: { id: number; state: LessonState }) =>
      // @ts-ignore
      api(`PUT /lessons/${id}/state`, { root: supportApiBase, data: { state } }),
    {
      onSuccess: (_, { id }) => {
        queryClient.invalidateQueries(queryKeys.lessons);
        queryClient.invalidateQueries(queryKeys.lesson(id));
      },
    }
  );
};
